import { render } from "./UnboxControls.vue?vue&type=template&id=47f4a519&scoped=true"
import script from "./UnboxControls.vue?vue&type=script&lang=js"
export * from "./UnboxControls.vue?vue&type=script&lang=js"

import "./UnboxControls.vue?vue&type=style&index=0&id=47f4a519&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47f4a519"]])

export default __exports__